const ATM_BANK_CODE = 'F001';

const PAYMENT_MAX_VALUE = 9999999;
const PAYMENT_MIN_VALUE = 1000;

const PAYMENT_FROM_CREDIT_MAX_VALUE = 300000;
const PAYMENT_FROM_CREDIT_MIN_VALUE = 1000;

export {
  ATM_BANK_CODE,
  PAYMENT_FROM_CREDIT_MAX_VALUE,
  PAYMENT_FROM_CREDIT_MIN_VALUE,
  PAYMENT_MAX_VALUE,
  PAYMENT_MIN_VALUE,
};
